import { render, staticRenderFns } from "./AppHeading.vue?vue&type=template&id=2b6c762f&scoped=true&"
import script from "./AppHeading.vue?vue&type=script&lang=ts&"
export * from "./AppHeading.vue?vue&type=script&lang=ts&"
import style0 from "./AppHeading.vue?vue&type=style&index=0&id=2b6c762f&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6c762f",
  null
  
)

export default component.exports